// extracted by mini-css-extract-plugin
export default {"floatButton":"_3ecd2deea0","floatButtonCard":"e6d07d4f00"};